import Feedback from "../components/Feedback";
import FeedbackDisplayArea from "../components/FeedbackDisplayArea";
import PageContent from "../components/PageContent";
import { browseFeedbackBranchwise } from "../util/adminDashboard/browseFeedbackBranchwise";
import { getActiveBranchIds } from "../util/multipleBranch/getActiveBranchId";
import { filterSavedFeedbacks } from "../util/filterSavedFeedbacks";
export default function SavedFeedbacks() {
  let data = JSON.parse(sessionStorage.getItem("mainData"));
  const branches = JSON.parse(localStorage.getItem("branches"));
  const activeBranches = getActiveBranchIds(branches);

  // now we filter only those feedbacks whose book

  const subData = filterSavedFeedbacks(data);
  console.log(subData);
  let feedbackCounterIndex = browseFeedbackBranchwise(subData, activeBranches);
  return (
    <PageContent>
      {data ? (
        <FeedbackDisplayArea
          data={subData}
          feedbackIndex={feedbackCounterIndex}
        />
      ) : (
        <>
          <h3>No Data Present</h3>
        </>
      )}
    </PageContent>
  );
}
